import axiosInstance from "../../utilities/interceptorUtilities";
import { policiesFetchError } from "../../constants/messages";
import { getStates } from "./forms";
import { propertyTypes, liabilityTypes } from "../../constants/data";
import { setLoading, setPolicyType, setButtonHeader } from "./app";
import { setAlertModal } from "./app";
import { COMMERCIAL, PERSONAL } from "../../constants/keys";

export const GET_AGENT_POLICIES = "GET_AGENT_POLICIES";
export const SET_ACTIVE_POLICY = "SET_ACTIVE_POLICY";

export const getAgentPolicies = (agentCode, parentAgentCode, userClass) => {
  return async (dispatch, getState) => {
    try {
      const url =
        process.env.REACT_APP_API_URL + "/api/Claims/ViewAllAgentPolicies";
      const body = { agentCode: agentCode, userClass: userClass };

      const response = await axiosInstance.post(url, body, {
        headers: { "content-type": "application/json" },
        withCredentials: true,
      });

      let agentPolicyTypes = [
        ...new Set([...propertyTypes, ...liabilityTypes, "WC", "AUTO", "HOME"]),
      ];
      let policies = response.data;
      let personalPolicies = await policies.filter(
        (i) =>
          i.PolicyIndicator === "1" &&
          agentPolicyTypes.includes(i.PolicyType.trim())
      );
      let commercialPolicies = await policies.filter(
        (i) =>
          i.PolicyIndicator === "2" &&
          agentPolicyTypes.includes(i.PolicyType.trim())
      );
      personalPolicies = [...new Set(personalPolicies)];
      commercialPolicies = [...new Set(commercialPolicies)];

      const policyObject = {
        personal: personalPolicies.length > 0,
        commercial: commercialPolicies.length > 0,
      };

      // Checking for no activePolicy will only happen initially resulting in policy type to be auto selected
      // Once an activePolicy is selected, the policy type will persist
      if (!getState().policies.activePolicy) {
        if (personalPolicies.length > 0) {
          dispatch(
            setPolicyType(
              policyObject.personal,
              policyObject.commercial,
              PERSONAL
            )
          );
        } else {
          dispatch(
            setPolicyType(
              policyObject.personal,
              policyObject.commercial,
              COMMERCIAL
            )
          );
        }
      }

      if (personalPolicies.length > 0 && commercialPolicies.length > 0) {
        dispatch(setButtonHeader(true));
      } else {
        dispatch(setButtonHeader(false));
      }

      dispatch(setLoading(false));
      dispatch({
        type: GET_AGENT_POLICIES,
        personalPolicies,
        commercialPolicies,
      });
    } catch (err) {
      dispatch(setLoading(false));
      dispatch(setAlertModal(true, "error", policiesFetchError));
      setTimeout(() => {
        dispatch(setAlertModal(false, ""));
      }, 5000);
    }
  };
};

export const setActivePolicy = (policy) => {
  return async (dispatch) => {
    dispatch({ type: SET_ACTIVE_POLICY, policy });
    dispatch(getStates());
  };
};
